import React from 'react';
import { noop } from 'lodash';
import '../../styles/MyDashboard/DashboardTable.scss';
import {
  Table, TableBody, TableHeader, TableHead, TableRow
} from '@thd-olt-component-react/core-ui';
import { Error } from '@material-ui/icons/index';
import TableSortLabel from '../common/TableSortLabel/TableSortLabel';
import TableSortLabelDropdown from '../common/TableSortLabel/TableSortLabelDropdown';
import { getExpiryLabel } from '../../utils/daysToExpire';

const DashboardTable = ({
  data, sort, filter, handleSortChange, handleFilterChange, columnHeaders
}) => {

  // if highlighting we don't execute the callback
  function handleClickOrHighlight(func = noop) {
    return function executeClickOrDrag(e) {
      if (!isHighlightingText()) {
        func(e);
      }
    };
  }

  // we don't want a redirect if someone is trying to
  // highlight the name, this check to see if its being highlighted
  function isHighlightingText() {
    return window.getSelection().type === 'Range';
  }

  return (
    <div className="p2p-table__wrapper">
      <Table className="slm__table" aria-label="simple table">
        <TableHead>
          <TableRow>
            {columnHeaders.map((header, index) => {
              if (header.sortable && sort) {
                return (
                  <th key={index} className={`p2p-table__header ${header.className || ''} ${header?.items?.type && 'p2p-table__header-dropdown'}`}>
                    {header?.items?.type
                      ? (
                        <TableSortLabelDropdown
                          handleFilterChange={handleFilterChange}
                          header={header}
                          filter={filter}
                        />
                      )
                      : (
                        <TableSortLabel
                          field={header.key}
                          sort={sort}
                          handleSortChange={handleSortChange}
                        >
                          {header.value}
                        </TableSortLabel>
                      )}
                  </th>
                );
              }
              return (
                <TableHeader
                  key={index}
                  className={`p2p-table__header ${header.className || ''}`}
                >
                  <div
                    className="p2p-table__heading-text"
                    {...header.testId ? { 'data-testid': `table-header-${header.testId}` } : null}
                  >
                    {header.value}
                  </div>
                </TableHeader>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {/** TODO: Refactor to use harmony component when they accecpt events */}
          {data.map((row, index) => {
            const expiryLabel = getExpiryLabel(row.deadlineToApply);

            return (
              <tr
                key={`${index}-${row.candidateId || row.jobPostingId || row.applicantId}`}
                tabIndex={-1}
                onMouseUp={handleClickOrHighlight(row.onRowClick)}
                className="p2p-table__row"
                data-testid="dashboard-table-row"
              >
                {columnHeaders.map((header, i) => {
                  return (
                    <td
                      key={i + 'value'}
                      className={`p2p-table__cell ${header.className || ''}`}
                    >
                      <div
                        {...header.testId ? { 'data-testid': header.testId } : null}
                        className="p2p-table__cell-offset"
                      >
                        {row[header.key]}
                      </div>
                      {header.key === 'title' && (
                        expiryLabel && (
                          <div className="p2p-table__expire-soon" style={{ color: expiryLabel.color }}>
                            <Error className="p2p-table__expire-soon-icon" />
                            {expiryLabel.text}
                          </div>
                        )
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default DashboardTable;
